import React from "react";
import { useQuery } from "@tanstack/react-query";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import organizationservice from "../../../service/organizationservice";
import pathnames from "../../../constants/pathnames";
import FirsBusinessLimitDialog from "./FirsBusinessLimitDialog";

const FirsBusinessLimit = ({ organizationId }) => {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = React.useState(false);

  const summaryQuery = useQuery({
    queryKey: ["firs-businesses-summary", organizationId],
    enabled: !!organizationId,
    queryFn: () => organizationservice.getFirsBusinesses(organizationId, { page: 1, limit: 1 }),
  });

  const result = summaryQuery.data?.data?.data;
  const businessCount = result?.businessCount ?? 0;
  const maxBusinesses = result?.maxBusinesses;
  const viewAllPath = `${pathnames.ORGANIZATIONS_FIRS_BUSINESSES}/${organizationId}`;

  return (
    <React.Fragment>
      <div className="mb-2 fs-sm d-flex align-items-center">
        <span className="text-secondary me-2">NRS Businesses:</span>
        <span className="flex-grow-1">
          {businessCount} of {maxBusinesses === null ? "Unlimited" : maxBusinesses ?? "-"}
        </span>
        <Button size="small" variant="text" disabled={summaryQuery.isPending} onClick={() => setIsOpen(true)}>
          Manage
        </Button>
      </div>

      <FirsBusinessLimitDialog
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        organizationId={organizationId}
        maxBusinesses={maxBusinesses}
        businessCount={businessCount}
        onSaved={() => summaryQuery.refetch()}
        footer={
          <Button size="small" variant="text" className="px-0" onClick={() => navigate(viewAllPath)}>
            View all businesses
          </Button>
        }
      />
    </React.Fragment>
  );
};

export default FirsBusinessLimit;
